<template>
    <div class="c-instagramfeed">
        <div class="c-instagramfeed__heading">
            <h2>#minifabrikken</h2>
            <div class="subheading">
                <a
                    alt="Minifabrikken Instagram"
                    rel="noreferrer"
                    href="https://www.instagram.com/minifabrikken"
                    target="_blank"
                    >@minifabrikken</a
                >
            </div>
        </div>
        <div
            v-if="feed"
            class="c-instagramfeed__grid"
            :class="'c-instagramfeed__grid--' + gridSize"
        >
            <a
                :href="postLink(index)"
                target="_blank"
                rel="noreferrer"
                class="c-instagramfeed__post"
                :alt="'Instagram post fra d. ' + postDate(index)"
                v-for="index in gridSize"
                :key="index"
                :style="{ backgroundImage: 'url(' + postImage(index) + ')' }"
            >
                Instagram post fra d. {{ postDate(index) }}
            </a>
            <div class="c-instagramfeed__placeholder" v-if="!feed"></div>
        </div>
        <div
            v-if="!feed"
            class="c-instagramfeed__grid"
            :class="'c-instagramfeed__grid--' + gridSize"
        >
            <div class="c-instagramfeed__placeholder"></div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { debounce } from '../scripts/helpers'

export default {
    name: 'Instragramfeed',
    props: {
        callOutLink: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            feed: [],
            gridSize: 12,
        }
    },
    computed: {
        ...mapState({
            translations: (state) => state.app.translations,
        }),
    },
    methods: {
        postLink(index) {
            if (typeof this.feed[index - 1] === 'undefined') {
                return ''
            } else {
                return this.feed[index - 1].permalink
            }
        },
        postImage(index) {
            if (typeof this.feed[index - 1] === 'undefined') {
                return ''
            } else {
                return this.feed[index - 1].imageUrl
            }
        },
        postDate(index) {
            if (typeof this.feed[index - 1] === 'undefined') {
                return ''
            } else {
                return this.feed[index - 1].postedAt
            }
        },
        fetch: function () {
            axios
                .get(
                    'https://api.socialfeeds.qnty.dk/feed/minifabrikken/instagram',
                    {
                        params: {
                            limit: this.gridCount(),
                        },
                    }
                )
                .then((result) => {
                    if (result.data) {
                        this.feed = result.data.feed
                    }
                })
        },
        gridCount: function () {
            const vw = Math.max(
                document.documentElement.clientWidth || 0,
                window.innerWidth || 0
            )

            let gridSize = 12

            if (vw > 1599) {
                gridSize = 16
            }

            if (vw <= 1599) {
                gridSize = 14
            }

            if (vw <= 1399) {
                gridSize = 12
            }

            if (vw <= 1099) {
                gridSize = 10
            }

            if (vw <= 899) {
                gridSize = 8
            }

            if (vw <= 699) {
                gridSize = 6
            }

            if (vw <= 499) {
                gridSize = 4
            }

            this.gridSize = gridSize
            return gridSize
        },
    },
    created() {
        this.gridCount()
        setTimeout(() => {
            this.fetch()
        }, 2500)
    },
    mounted() {
        window.addEventListener('resize', debounce(this.fetch, 500))
    },
    destroyed() {
        window.removeEventListener('resize', this.fetch)
    },
}
</script>


<style lang="scss">
@import '../../scss/abstracts/variables.scss';
@import '../../scss/abstracts/_mixins.scss';

.c-instagramfeed {
    margin-top: 50px;
    margin-bottom: 42px;
    position: relative;

    &__heading {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 28px;

        h2 {
            margin-bottom: 1px;
        }

        .subheading {
            font-size: 14px;
            letter-spacing: -0.11px;
            line-height: 22px;
            text-align: center;
        }
    }

    &__grid {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        &--16 {
            .c-instagramfeed__post {
                width: calc((100% / 8) - 6px);
            }
        }

        &--14 {
            .c-instagramfeed__post {
                width: calc((100% / 7) - 6px);
            }
        }

        &--12 {
            .c-instagramfeed__post {
                width: calc((100% / 6) - 6px);
            }
        }

        &--10 {
            .c-instagramfeed__post {
                width: calc((100% / 5) - 6px);
            }
        }

        &--8 {
            .c-instagramfeed__post {
                width: calc((100% / 4) - 6px);
            }
        }

        &--6 {
            .c-instagramfeed__post {
                width: calc((100% / 3) - 6px);
            }
        }

        &--4 {
            .c-instagramfeed__post {
                width: calc((100% / 2) - 3px);
            }
        }
    }

    &__post {
        @include aspectratio(235, 235);
        margin-bottom: 6px;
        background-position: center;
        background-size: cover;
        background-color: $c-light-grey;
        font-size: 0px;
        line-height: 0px;
    }
}

@media all and (max-width: 699px) {
    .c-instagramfeed {
        &__heading {
            position: absolute;
            z-index: 2;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            padding: 57px 20px 48px;
            background: #fff;
            max-width: 205px;

            h2 {
                font-size: 27px;
                letter-spacing: -0.21px;
                line-height: 42px;
                text-align: center;
                margin-bottom: 13px;
            }
        }
    }
}
</style>
